'use client';

import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from '@headlessui/react';
import React, { Fragment } from 'react';
import { cn } from '@/lib/utils';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import HeaderOnlineShopSearch from '@/shared/HeaderOnlineShopSearch';
import HeadlessModal from './shared/HeadlessModal';
import { useUserStore } from '@/stores/customer/user';
import { useUserStore as useRestaurantProfileStore } from '@/stores/restuarant/user';
import { useStore } from 'zustand';

interface DrawerMenuProps {
  showNavSearch?: boolean;
  popoverClass?: string;
  showPopoverSearch?: boolean;
}

export default function SearchPopover(props: DrawerMenuProps) {
  const { showNavSearch, popoverClass = '', showPopoverSearch = true } = props;
  const [isVisible, setIsVisible] = React.useState(false);

  const user = useUserStore((state) => state.user);
  const restaurantProfile = useStore(
    useRestaurantProfileStore,
    (state) => state.user
  );

  const isUser = (user || restaurantProfile) ?? null;

  const handleShow = (isOpen: boolean) => {
    setIsVisible(isOpen);
  };

  if (!showNavSearch) return null;

  return (
    <>
      {showPopoverSearch ? (
        <Popover className={cn('relative', popoverClass)}>
          {({ open }) => (
            <div>
              <PopoverButton
                onClick={() => handleShow(!open)}
                className={` ${open ? '' : 'text-opacity-90'} group inline-flex items-center rounded-md px-3 py-2 text-base font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
                // aria-label={t(`${NOTIFICATIONS}.view_notifications`)}
              >
                <MagnifyingGlassIcon
                  className={`h-6 w-6 ${isVisible ? 'text-primary' : ''} `}
                  aria-hidden="true"
                />
              </PopoverButton>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <PopoverPanel
                  className={cn(
                    'absolute z-40 mt-3 w-[280px] max-w-sm sm:w-[380px] sm:px-0 md:right-0 lg:max-w-3xl',
                    isUser ? '-right-[65px] sm:-right-[50px]' : '-right-[50px]'
                  )}
                >
                  <div className="space-y-5 divide-y divide-gray-200 overflow-hidden rounded-lg border border-gray-100 bg-white p-4 shadow-lg">
                    {showNavSearch && (
                      <HeaderOnlineShopSearch focusActive={true} />
                    )}
                  </div>
                </PopoverPanel>
              </Transition>
            </div>
          )}
        </Popover>
      ) : (
        <>
          <button onClick={() => handleShow(!isVisible)}>
            <MagnifyingGlassIcon
              className={`h-6 w-6 ${isVisible ? 'text-primary' : ''} `}
              aria-hidden="true"
            />
          </button>
          <HeadlessModal
            isOpen={isVisible}
            closeModal={() => {
              setIsVisible(false);
            }}
            showCloseIcon={false}
            dialogPanelClassName="w-[90%] md:w-[70%] lg:w-[50%] min-h-fit rounded-md"
          >
            {showNavSearch && <HeaderOnlineShopSearch focusActive={true} />}
          </HeadlessModal>
        </>
      )}
    </>
  );
}
